import { request, COUPON_URL, PROJECT_URL, getAuthToken } from './axiosInstance';
import axios from 'axios';

// Validate ONE coupon by its exact code.
//
// The checkout previously called getCoupons() and rendered every code and amount in
// the store into a dropdown, so any visitor could read all discount codes from the
// network tab (SEC-19). This looks up only a code the user already typed and never
// enumerates. WooCommerce re-validates on order creation regardless — this exists so
// the UI can show the discount before submitting.
//
// Resolves to { valid, code, discount_type, amount }, or throws with a user-facing
// message for not-found (404), expired (410) and exhausted coupons.
export async function validateCoupon(code) {
    const token = await getAuthToken();
    try {
        const response = await axios.post(
            `${PROJECT_URL}wp-json/custom/v1/validate-coupon`,
            { code },
            { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.message || 'Could not verify that coupon. Please try again.'
        );
    }
}

// Get coupons — admin only (DshCoupons.jsx). NOT for the storefront: listing every
// coupon to a shopper exposes codes they were never given. Use validateCoupon there.
export async function getCoupons() {
    try {
        const response = await request('GET', COUPON_URL)
        return response
    } catch (error) {
        console.log(error)
    }
}

// Add Coupon
export async function addCoupon(data) {
    try {
        const response = await request('POST', COUPON_URL, data)
        return response
    } catch (error) {   
        console.log(error)        
    }
}

// Delete coupon
export async function deleteCoupon(id) {
    try {   
        const response = await request('DELETE', `${COUPON_URL}/${id}`)
        return response
    } catch (error) {   
        console.log(error)        
    }
}